export class DialogModelViewBill{
    constructor(
      public data:any
    ) {}
  }